import React, { useContext, useEffect, useState } from 'react'
import { useTheme } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CheckIcon from '@mui/icons-material/Check'
import LaunchIcon from '@mui/icons-material/Launch'
import SubtitlesIcon from '@mui/icons-material/Subtitles'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import messagesLib from '../../libs/messages'
import { linkCode, isLinkAbrivel } from '../../libs/hiperpayLink'
import { isMetaOfficialProvider } from '../../libs/metaTemplates'
import { ApiDataWrapperContext } from '../../contexts/ApiDataWrapper'
import { sanitizeSgpFileUrl } from './MessageListItem'

// Atalhos do que o operador faz depois de ler a linha: mandar o link de
// pagamento para o cliente, abrir a página, ou ver o payload cru quando o
// suporte precisa do que exatamente foi para a Meta.
//
// O link de pagamento nunca é carregado sozinho — sem iframe, sem prefetch. Abrir
// é sempre clique do operador, para não registrar visita nem gastar validade de
// uma cobrança real.
//
// Coluna estreita da tabela densa: cada ação vira só um ícone com tooltip — o
// rótulo escrito de antes não cabe mais ao lado.
const CLASSE_BOTAO = 'grid h-[27px] w-[27px] place-items-center rounded-md border border-transparent hover:bg-gray-500/10 transition-colors'

export default function MessageQuickActions({ message, onVerPayload }) {
  const theme = useTheme()
  const { provider } = useContext(ApiDataWrapperContext)
  const [copiado, setCopiado] = useState(false)

  useEffect(() => {
    if (!copiado) return
    const t = setTimeout(() => setCopiado(false), 2000)
    return () => clearTimeout(t)
  }, [copiado])

  const link = message.link || ''
  const abrivel = isLinkAbrivel(link)
  const arquivo = messagesLib.getFileFromMessage(message.message || '')
  const ehMeta = isMetaOfficialProvider(provider)

  if (!link && !arquivo && !ehMeta) return null

  const estiloBotao = {
    color: theme.isDark ? '#767c86' : '#85909c',
  }

  return (
    <div className="flex items-center justify-end gap-0.5">
      {link && (
        // O `span` é o alvo de verdade do Tooltip (ele precisa de um nó DOM pra
        // medir a posição do balão). O CopyToClipboard clona o próprio botão sem
        // repassar a ref adiante — colocando o Tooltip direto nele, o balão
        // ficaria sem onde se ancorar.
        <Tooltip title={copiado ? 'Copiado' : `Copiar link de pagamento · ${linkCode(link)}`}>
          <span>
            <CopyToClipboard text={link} onCopy={() => setCopiado(true)}>
              <button
                type="button"
                className={CLASSE_BOTAO}
                style={estiloBotao}
                onClick={(e) => e.stopPropagation()}
              >
                {copiado ? <CheckIcon style={{ fontSize: 16 }} /> : <ContentCopyIcon style={{ fontSize: 16 }} />}
              </button>
            </CopyToClipboard>
          </span>
        </Tooltip>
      )}

      {abrivel && (
        <Tooltip title="Abrir">
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className={CLASSE_BOTAO}
            style={estiloBotao}
          >
            <LaunchIcon style={{ fontSize: 16 }} />
          </a>
        </Tooltip>
      )}

      {ehMeta && (
        <Tooltip title="Payload">
          <button
            type="button"
            className={CLASSE_BOTAO}
            style={estiloBotao}
            onClick={(e) => { e.stopPropagation(); onVerPayload() }}
          >
            <SubtitlesIcon style={{ fontSize: 16 }} />
          </button>
        </Tooltip>
      )}

      {/* O endereço passa pelo mesmo saneamento do conteúdo expandido: URL do SGP
          chega sem esquema e com "/.pdf" no fim, e sem isso o link quebra. */}
      {arquivo && (
        <Tooltip title="Arquivo">
          <a
            href={sanitizeSgpFileUrl(arquivo.url)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className={CLASSE_BOTAO}
            style={estiloBotao}
          >
            <InsertDriveFileIcon style={{ fontSize: 16 }} />
          </a>
        </Tooltip>
      )}
    </div>
  )
}
